export const lowZIndex = 1
export const mediumZIndex = 5
